var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.column.visible
    ? _c(
        "td",
        {
          class: [
            _vm.columnCellClass,
            _vm.isEditableFunction || _vm.isEditableBoolean
              ? "column-editable"
              : "column-not-editable",
            "md-table-cell",
          ],
          style: { width: _vm.column.width, "font-size": _vm.fontSize },
        },
        [
          _c("div", { staticClass: "md-table-cell-container" }, [
            _vm.allowTooltips &&
            _vm.row &&
            _vm.row[_vm.column.name] &&
            _vm.row[_vm.column.name] != "" &&
            _vm.column.customTooltip !== false
              ? _c(
                  "div",
                  { staticClass: "datatable-tooltip" },
                  [
                    _vm.column.customTooltip &&
                    typeof _vm.column.customTooltip === "function"
                      ? [_vm._v(_vm._s(_vm.column.customTooltip(_vm.row)))]
                      : _vm.column.customTooltip &&
                        typeof _vm.column.customTooltip === "string"
                      ? [_vm._v(_vm._s(_vm.column.customTooltip))]
                      : [_vm._v(_vm._s(_vm.row[_vm.column.name]))],
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.column.visible && _vm.column.slotName
              ? _c(
                  "div",
                  { class: "table-cell-slot-" + _vm.column.slotName },
                  [
                    _vm._t("default", function () {
                      return [_vm._v("Where is your slot content?")]
                    }),
                  ],
                  2
                )
              : _vm.isSimpleCell &&
                !_vm.isEditableFunction &&
                !_vm.isEditableBoolean
              ? _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.row[_vm.column.name]) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm.isSimpleCell &&
                (_vm.isEditableFunction || _vm.isEditableBoolean)
              ? _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _vm.column.type === "textarea"
                      ? _c("div", [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.row[_vm.column.name],
                                expression: "row[column.name]",
                              },
                            ],
                            attrs: {
                              disabled:
                                !_vm.isEditableFunction &&
                                !_vm.isEditableBoolean,
                              name: _vm.column.name + _vm.row.id,
                            },
                            domProps: { value: _vm.row[_vm.column.name] },
                            on: {
                              blur: function ($event) {
                                return _vm.$emit(
                                  "setRowBlur",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              focus: function ($event) {
                                return _vm.$emit(
                                  "setFocus",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              change: function ($event) {
                                return _vm.$emit(
                                  "setRowChanged",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.row,
                                  _vm.column.name,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      : _vm.column.type === "checkbox"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-input-container md-theme-default",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "md-checkbox md-theme-default",
                                  class: {
                                    "md-checked": _vm.row[_vm.column.name],
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs[
                                        _vm.column.name + _vm.row.id
                                      ].click()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-checkbox-container",
                                      attrs: { tabindex: "0" },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.row[_vm.column.name],
                                            expression: "row[column.name]",
                                          },
                                        ],
                                        ref: _vm.column.name + _vm.row.id,
                                        attrs: {
                                          type: "checkbox",
                                          name: _vm.column.name + _vm.row.id,
                                          tabindex: "-1",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.row[_vm.column.name]
                                          )
                                            ? _vm._i(
                                                _vm.row[_vm.column.name],
                                                null
                                              ) > -1
                                            : _vm.row[_vm.column.name],
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.row[_vm.column.name],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.row,
                                                      _vm.column.name,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.row,
                                                      _vm.column.name,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.row,
                                                  _vm.column.name,
                                                  $$c
                                                )
                                              }
                                            },
                                            function ($event) {
                                              return _vm.$emit(
                                                "setRowChanged",
                                                _vm.row,
                                                _vm.column
                                              )
                                            },
                                          ],
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm.inputType === "text"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-input-container md-theme-default md-has-value",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.row[_vm.column.name],
                                    expression: "row[column.name]",
                                  },
                                ],
                                staticClass: "md-input",
                                attrs: {
                                  type: "text",
                                  name: _vm.column.name + _vm.row.id,
                                  disabled:
                                    !_vm.isEditableFunction &&
                                    !_vm.isEditableBoolean,
                                },
                                domProps: { value: _vm.row[_vm.column.name] },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$emit(
                                      "setRowBlur",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.$emit(
                                      "setFocus",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  change: function ($event) {
                                    return _vm.$emit(
                                      "setRowChanged",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.row,
                                      _vm.column.name,
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm.inputType === "number"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-input-container md-theme-default",
                            },
                            [
                              typeof _vm.column.min !== "undefined" ||
                              typeof _vm.column.max !== "undefined"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.row[_vm.column.name],
                                        expression: "row[column.name]",
                                      },
                                    ],
                                    staticClass: "md-input",
                                    attrs: {
                                      type: "number",
                                      name: _vm.column.name + _vm.row.id,
                                      disabled:
                                        !_vm.isEditableFunction &&
                                        !_vm.isEditableBoolean,
                                      min:
                                        typeof _vm.column.min == "function"
                                          ? _vm.column.min(_vm.row)
                                          : _vm.column.min,
                                      max:
                                        typeof _vm.column.max == "function"
                                          ? _vm.column.max(_vm.row)
                                          : _vm.column.max,
                                      oninput: "validity.valid||(value='');",
                                    },
                                    domProps: {
                                      value: _vm.row[_vm.column.name],
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.$emit(
                                          "setRowBlur",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      focus: function ($event) {
                                        return _vm.$emit(
                                          "setFocus",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      change: function ($event) {
                                        return _vm.$emit(
                                          "setRowChanged",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.row,
                                          _vm.column.name,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.row[_vm.column.name],
                                        expression: "row[column.name]",
                                      },
                                    ],
                                    staticClass: "md-input",
                                    attrs: {
                                      type: "number",
                                      name: _vm.column.name + _vm.row.id,
                                      disabled:
                                        !_vm.isEditableFunction &&
                                        !_vm.isEditableBoolean,
                                    },
                                    domProps: {
                                      value: _vm.row[_vm.column.name],
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.$emit(
                                          "setRowBlur",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      focus: function ($event) {
                                        return _vm.$emit(
                                          "setFocus",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      change: function ($event) {
                                        return _vm.$emit(
                                          "setRowChanged",
                                          _vm.row,
                                          _vm.column
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.row,
                                          _vm.column.name,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                            ]
                          ),
                        ])
                      : _vm.inputType === "checkbox"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-input-container md-theme-default",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.row[_vm.column.name],
                                    expression: "row[column.name]",
                                  },
                                ],
                                staticClass: "md-input",
                                attrs: {
                                  type: "checkbox",
                                  name: _vm.column.name + _vm.row.id,
                                  disabled:
                                    !_vm.isEditableFunction &&
                                    !_vm.isEditableBoolean,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.row[_vm.column.name]
                                  )
                                    ? _vm._i(_vm.row[_vm.column.name], null) >
                                      -1
                                    : _vm.row[_vm.column.name],
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$emit(
                                      "setRowBlur",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.$emit(
                                      "setFocus",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.row[_vm.column.name],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.row,
                                              _vm.column.name,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.row,
                                              _vm.column.name,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.row, _vm.column.name, $$c)
                                      }
                                    },
                                    function ($event) {
                                      return _vm.$emit(
                                        "setRowChanged",
                                        _vm.row,
                                        _vm.column
                                      )
                                    },
                                  ],
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm.inputType === "password"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-input-container md-theme-default",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.row[_vm.column.name],
                                    expression: "row[column.name]",
                                  },
                                ],
                                staticClass: "md-input",
                                attrs: {
                                  type: "password",
                                  name: _vm.column.name + _vm.row.id,
                                  disabled:
                                    !_vm.isEditableFunction &&
                                    !_vm.isEditableBoolean,
                                },
                                domProps: { value: _vm.row[_vm.column.name] },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$emit(
                                      "setRowBlur",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.$emit(
                                      "setFocus",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  change: function ($event) {
                                    return _vm.$emit(
                                      "setRowChanged",
                                      _vm.row,
                                      _vm.column
                                    )
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.row,
                                      _vm.column.name,
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.row[_vm.column.tooltip]
                    ? _c("span", { staticClass: "wb-tooltip" }, [
                        _vm._v(_vm._s(_vm.row[_vm.column.tooltip])),
                      ])
                    : _vm._e(),
                ])
              : _vm.column.visible &&
                _vm.column.type !== "boolean" &&
                _vm.column.type !== "autocomplete" &&
                (_vm.column.type === "dateWithTime" ||
                  _vm.column.type === "dateFromTo") &&
                !_vm.column.cellTemplate &&
                !_vm.column.isObjectSelection &&
                !_vm.column.isButtonColumn &&
                !_vm.column.isObjectMultiSelection
              ? _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _vm.column.type === "dateWithTime"
                      ? _c(
                          "div",
                          [
                            _c("date-picker-wrapper", {
                              ref: "datePickerWrapper",
                              staticClass: "datepicker-custom-wrapper",
                              attrs: {
                                row: _vm.row,
                                disabled:
                                  !_vm.isEditableFunction &&
                                  !_vm.isEditableBoolean,
                                placeholder: _vm.dataTimePlaceholder,
                                datepickerOptions: _vm.column.datepickerOptions,
                                format: _vm.column.format,
                                limit: _vm.column.limit,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit(
                                    "setRowChanged",
                                    _vm.row,
                                    _vm.column,
                                    true
                                  )
                                },
                              },
                              nativeOn: {
                                blur: function ($event) {
                                  return _vm.$emit(
                                    "setRowBlur",
                                    _vm.row,
                                    _vm.column
                                  )
                                },
                              },
                              model: {
                                value: _vm.row[_vm.column.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.row, _vm.column.name, $$v)
                                },
                                expression: "row[column.name]",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.row[_vm.column.tooltip]
                    ? _c("span", { staticClass: "wb-tooltip" }, [
                        _vm._v(_vm._s(_vm.row[_vm.column.tooltip])),
                      ])
                    : _vm._e(),
                ])
              : _vm.column.visible &&
                _vm.column.type !== "boolean" &&
                _vm.column.type !== "autocomplete" &&
                _vm.column.type === "time" &&
                !_vm.column.cellTemplate &&
                !_vm.column.isObjectSelection &&
                !_vm.column.isButtonColumn &&
                !_vm.column.isObjectMultiSelection
              ? _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.row[_vm.column.name],
                          expression: "row[column.name]",
                        },
                      ],
                      staticClass: "md-input",
                      attrs: {
                        type: "time",
                        name: _vm.column.name + _vm.row.id,
                        disabled:
                          !_vm.isEditableFunction && !_vm.isEditableBoolean,
                        min:
                          typeof _vm.column.min == "function"
                            ? _vm.column.min(_vm.row)
                            : _vm.column.min,
                        max:
                          typeof _vm.column.max == "function"
                            ? _vm.column.max(_vm.row)
                            : _vm.column.max,
                        oninput: "validity.valid||(value='');",
                      },
                      domProps: { value: _vm.row[_vm.column.name] },
                      on: {
                        blur: function ($event) {
                          return _vm.$emit("setRowBlur", _vm.row, _vm.column)
                        },
                        focus: function ($event) {
                          return _vm.$emit("setFocus", _vm.row, _vm.column)
                        },
                        change: function ($event) {
                          return _vm.$emit("setRowChanged", _vm.row, _vm.column)
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.row,
                            _vm.column.name,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.row[_vm.column.tooltip]
                    ? _c("span", { staticClass: "wb-tooltip" }, [
                        _vm._v(_vm._s(_vm.row[_vm.column.tooltip])),
                      ])
                    : _vm._e(),
                ])
              : _vm.column.visible &&
                _vm.column.type !== "boolean" &&
                _vm.column.type === "autocomplete" &&
                !(
                  _vm.column.type === "dateWithTime" &&
                  _vm.column.type === "dateFromTo"
                ) &&
                !_vm.column.cellTemplate &&
                !_vm.column.isObjectSelection &&
                !_vm.column.isButtonColumn &&
                !_vm.column.isObjectMultiSelection
              ? _c("div", { staticStyle: { width: "100%" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("md-autocomplete", {
                            attrs: {
                              fetch: function (q) {
                                return _vm.column.fetchAutoComplete(
                                  q,
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              "print-attribute": "name",
                              debounce: 100,
                              disabled:
                                !_vm.isEditableFunction &&
                                !_vm.isEditableBoolean,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit(
                                  "setRowChanged",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              focus: function ($event) {
                                return _vm.$emit(
                                  "setFocus",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                              selected: function ($event) {
                                return _vm.$emit(
                                  "setRowSelect",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                            },
                            model: {
                              value: _vm.row[_vm.column.name],
                              callback: function ($$v) {
                                _vm.$set(_vm.row, _vm.column.name, $$v)
                              },
                              expression: "row[column.name]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.row[_vm.column.tooltip]
                    ? _c("span", { staticClass: "wb-tooltip" }, [
                        _vm._v(_vm._s(_vm.row[_vm.column.tooltip])),
                      ])
                    : _vm._e(),
                ])
              : _vm.column.visible &&
                !_vm.column.cellTemplate &&
                _vm.column.type === "boolean"
              ? _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("setRowChanged", _vm.row, _vm.column)
                      },
                    },
                    nativeOn: {
                      blur: function ($event) {
                        return _vm.$emit("setRowBlur", _vm.row, _vm.column)
                      },
                    },
                  },
                  [
                    _vm.isEditableFunction || _vm.isEditableBoolean
                      ? _c(
                          "md-switch",
                          {
                            model: {
                              value: _vm.row[_vm.column.name],
                              callback: function ($$v) {
                                _vm.$set(_vm.row, _vm.column.name, $$v)
                              },
                              expression: "row[column.name]",
                            },
                          },
                          [
                            _vm.listOfOptionsForSwitch
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.row[_vm.column.name]
                                        ? _vm.listOfOptionsForSwitch[0]
                                        : _vm.listOfOptionsForSwitch[1]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _c("div", [
                          _vm.listOfOptionsForSwitch && _vm.row[_vm.column.name]
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.listOfOptionsForSwitch[0])),
                              ])
                            : _vm.listOfOptionsForSwitch &&
                              _vm.row[_vm.column.name]
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.listOfOptionsForSwitch[1])),
                              ])
                            : _c("div", [
                                _vm._v(_vm._s(_vm.row[_vm.column.name])),
                              ]),
                        ]),
                  ],
                  1
                )
              : _vm.column.visible &&
                !_vm.column.cellTemplate &&
                _vm.column.isObjectSelection
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "md-select md-theme-default",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "showSelectWindow",
                            $event,
                            _vm.row,
                            _vm.column,
                            _vm.getObjectList,
                            !_vm.isEditableFunction && !_vm.isEditableBoolean
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "md-menu" }, [
                        _c(
                          "span",
                          {
                            staticClass: "md-select-value",
                            attrs: { "md-menu-trigger": "" },
                          },
                          [_vm._v(_vm._s(_vm.computedSelectValue))]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm.column.visible &&
                !_vm.column.cellTemplate &&
                _vm.column.isObjectMultiSelection
              ? _c(
                  "div",
                  [
                    typeof _vm.row[_vm.column.name] !== "undefined"
                      ? _c(
                          "md-select",
                          {
                            attrs: {
                              name: _vm.column.name,
                              id: _vm.column.name,
                              disabled:
                                !_vm.isEditableFunction &&
                                !_vm.isEditableBoolean,
                              multiple: "",
                            },
                            nativeOn: {
                              blur: function ($event) {
                                return _vm.$emit(
                                  "setRowBlur",
                                  _vm.row,
                                  _vm.column
                                )
                              },
                            },
                            model: {
                              value: _vm.row[_vm.column.name],
                              callback: function ($$v) {
                                _vm.$set(_vm.row, _vm.column.name, $$v)
                              },
                              expression: "row[column.name]",
                            },
                          },
                          [
                            _vm.getObjectList
                              ? _vm._l(_vm.getObjectList, function (element) {
                                  return !(
                                    element.isHidden &&
                                    typeof element.isHidden === "function" &&
                                    element.isHidden(_vm.row)
                                  )
                                    ? _c(
                                        "md-option",
                                        {
                                          key: element.id,
                                          attrs: { value: element.id },
                                          on: {
                                            selected: function ($event) {
                                              return _vm.$emit(
                                                "setRowChanged",
                                                _vm.row,
                                                _vm.column
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(element.name))]
                                      )
                                    : _vm._e()
                                })
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm.column.visible &&
                _vm.column.isButtonColumn &&
                !_vm.column.cellTemplate
              ? _c(
                  "div",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button",
                        nativeOn: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.column.clickFunction(_vm.row)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v(_vm._s(_vm.column.buttonIcon))])],
                      1
                    ),
                  ],
                  1
                )
              : _vm.column.visible && _vm.column.cellTemplate
              ? _c("div", {
                  class:
                    _vm.column.columnClass &&
                    typeof _vm.column.columnClass === "function"
                      ? _vm.column.columnClass(_vm.row)
                      : "",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.column.cellTemplate &&
                        typeof _vm.column.cellTemplate === "function"
                        ? _vm.column.cellTemplate(_vm.row)
                        : _vm.column.cellTemplate
                    ),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.column.onClickRow(_vm.row)
                    },
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.adjustableColumnWidth && _vm.rowIndex === 0 && _vm.columnIndex > 0
            ? _c("div", {
                class: [_vm.column.name, "adjustable-column-width-border"],
                attrs: { draggable: false },
                on: {
                  mousedown: function ($event) {
                    return _vm.onmousedownAdjustableBorder(
                      _vm.row,
                      _vm.column,
                      $event
                    )
                  },
                },
              })
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }